export default "__VITE_ASSET__WeMCqzLy__"